export default {
      id: "file-type-document-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#file-type-document",
      toString: function () {
        return this.url;
      }
    }